export { default as tooltipSet } from './tooltipSet';


// WEBPACK FOOTER //
// ./src/containers/elements/Tooltips/constants/index.js